export default "__VITE_ASSET__C9rV$AUw__"